import React from 'react';
import ReactDOM from 'react-dom';
import generateStore from './redux/store';
import { Provider } from 'react-redux';
import App from './App';
import './config/i18n';
import 'moment/locale/es';

const store = generateStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);